import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PeymentService } from '@api/peyment.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-verification-bank-detail',
  templateUrl: './verification-bank-detail.component.html',
  styleUrls: ['./verification-bank-detail.component.scss']
})
export class VerificationBankDetailComponent implements OnInit {
  verificationId;
  verificationRequest;
  public destroy$ = new Subject<void>();

  constructor(private paymentService: PeymentService, private activatedRoute: ActivatedRoute , public router: Router) { }

  ngOnInit(): void {
    this.verificationId = this.activatedRoute.snapshot.params.id

    this.paymentService.requestBankAccountById(this.verificationId).pipe(takeUntil(this.destroy$))
    .subscribe((res: any) => {
      this.verificationRequest = res;
    });

  }
  postVerification() {
    const data = {id: +this.verificationId, approveStatus : true}
    this.paymentService.postRequestBankAccount(data).subscribe((res: any) => {
      if(res.status === 200 || res.status === 201){
        this.router.navigateByUrl('/verification-bank', {skipLocationChange: false});
      }
    }
    
    );
  }
  rejectVerification() {
    const data = {id: +this.verificationId, approveStatus : false}
    this.paymentService.postRequestBankAccount(data).subscribe((res: any) => {});
  }
  convertToCommas(x) {
    const value = Math.trunc(x);
    return value.toString().replace(/\B(?=(\d{4})+(?!\d))/g, '_');
  }
  ibanView(e) {
    if(!(e === null)){
      const ibanCharacter = e.substring(0,2);
      const ibanNumber = e.substring(2);
      e = ibanNumber.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
      return ibanCharacter + ' ' + e;
    }

  }
}
